import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/happy-box-v2.png")